const hasComboDiscount = (bestComboDiscount) => !!bestComboDiscount && Number(bestComboDiscount) !== 0;

export { hasComboDiscount };
